import path from 'path';

import _ from 'lodash';

export function buildPath(...args) {
  const elements = _.flatMap(args, (arg) => (_.isArray(arg) ? arg : [arg]));
  return path.join('/', ...elements);
}
